// src/components/Layout.jsx
import { useLocation } from "react-router-dom";
import config from "../config";

export default function Layout({ children }) {
  const location = useLocation();

  // ✅ Extra breed alleen voor Compliance
  const extraWideRoutes = ["/compliance"];

  // ✅ Normaal breed voor andere beheerpagina's
  const wideRoutes = [
    "/klantbeheer",
    "/adminbeheer",
    "/gebruikersbeheer",
    "/gebruikers-overzicht",
    "/gebruikersacties",
    "/mijnaanvragen",
    "/aanvragenbeoordelen",
    "/mailboxtoegang",
    "/agendatoegang",
    "/mfa-reset",
    "/klant-onboarding",
  ];

  const isExtraWide = extraWideRoutes.includes(location.pathname);
  const isWide = wideRoutes.includes(location.pathname);
  const isHome = location.pathname === "/";

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* 🚨 Banner voor staging */}
      {config.ENV === "staging" && (
        <div className="bg-red-600 text-white text-center py-2 font-bold shadow-md z-50">
          🚧 TEST omgeving actief ({config.ENV.toUpperCase()}) – niet gebruiken
          voor productie 🚧
        </div>
      )}

      <div className="flex-grow flex items-center justify-center px-4">
        {isHome ? (
          // ✅ Home krijgt géén vaste witte card
          <div className="w-full max-w-7xl">{children}</div>
        ) : (
          // ✅ Andere pagina’s in cards
          <div
            className={`bg-white shadow-xl rounded-2xl p-8 w-full ${
              isExtraWide
                ? "max-w-screen-xl"
                : isWide
                ? "max-w-4xl"
                : "max-w-md"
            }`}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
